export const listingsSearchCriteriaSurvey = {
    "title": "📋 Let's Set Up Your Search Criteria!",
    "description": "Help us find your perfect home by filling out the details below. \nIt'll only take a minute!",
    "logoPosition": "right",
    "completedHtml": "<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n  <style>\n    body {\n      font-family: 'Arial', sans-serif;\n      text-align: center;\n      padding: 20px;\n      background-color: #ffffff;\n      color: #333;\n      line-height: 1.6;\n    }\n    h3 {\n      font-size: 1.6rem;\n      color: #5271FF;\n    }\n    h4 {\n      font-size: 1rem;\n      margin-top: 10px;\n    }\n    a {\n      color: #0078ff;\n      text-decoration: none;\n    }\n    a:hover {\n      text-decoration: underline;\n    }\n  </style>\n</head>\n<body>\n  <h3>Thanks for completing the form 🚀</h3>\n  <h4>We'll start sending you real-time notifications for homes that match your criteria as soon as new listings are posted.</h4>\n  <h4>\n    You're all set! Please <a href=\"https://t.me/HomeScoutUK_bot\" target=\"_blank\">return to the Telegram bot</a>.\n  </h4>\n</body>\n</html>\n",
    "pages": [
        {
            "name": "page1",
            "elements": [
                {
                    "type": "radiogroup",
                    "name": "location_type",
                    "title": "🗺️ How would you like to search?",
                    "defaultValue": "neighborhood",
                    "colCount": 2,
                    "choices": [
                        { "value": "neighborhood", "text": "By neighbourhood" },
                        { "value": "postcode",     "text": "By postcode" },
                        { "value": "commute",      "text": "By commute time" }
                    ]
                },
                {
                    "type": "tagbox",
                    "name": "locations",
                    "title": "📍 Where are you looking to rent?",
                    "description": "Start typing the name of a neighbourhood, and select from the suggestions in the dropdown list.",
                    "visibleIf": "{location_type} = 'neighborhood'",
                    "isRequired": true,
                    "choices": [],
                    "placeholder": "Type or select an option",
                    "autocomplete": "name"
                },
                {
                    "type": "commute-filter",
                    "name": "commute_filter",
                    "title": "🚇 Where do you need to commute to?",
                    "isRequired": true,
                    "visibleIf": "{location_type} = 'commute'",
                    "clearIfInvisible": "onHidden"
                },
                {
                    "type": "tagbox",
                    "name": "commute_selected_areas",
                    "titleLocation": "hidden",
                    "visible": false,
                    "clearIfInvisible": "none",
                    "isRequired": false,
                    "choices": [],
                    "placeholder": "Type or select an area",
                    "autocomplete": "name"
                },
                {
                    "type": "tagbox",
                    "name": "postcode_areas",
                    "title": "📍 Where are you looking to rent?",
                    "description": "Start typing a postcode (e.g. SW, SW1H) and select from the suggestions, or tap areas on the map.",
                    "visibleIf": "{location_type} = 'postcode'",
                    "isRequired": true,
                    "choices": [],
                    "placeholder": "Type or select a postcode",
                    "autocomplete": "name"
                },
                {
                    "type": "slider",
                    "name": "bedrooms",
                    "title": "🛏️  What’s the number of bedrooms you need?",
                    "description": "Select the number of bedrooms you’ll consider.",
                    "isRequired": true,
                    "sliderType": "range",
                    "max": 5,
                    "customLabels": [
                        {
                            "value": 0,
                            "text": "Studio"
                        },
                        1,
                        2,
                        3,
                        4,
                        5
                    ],
                    "labelCount": 6
                },
                {
                    "type": "slider",
                    "name": "prices",
                    "title": "💷 What’s your monthly budget (GBP)?",
                    "description": "Select the rent price you’re willing to consider.",
                    "isRequired": true,
                    "sliderType": "range",
                    "max": 10000,
                    "step": 100,
                    "labelCount": 6
                },
                {
                    "type": "panel",
                    "name": "optional_filters",
                    "title": "✅ Advanced filters (optional)",
                    "description": "This section is optional - please fill out your must-haves below.",
                    "elements": [
                        {
                            "type": "text",
                            "name": "let_available_date",
                            "title": "📅 What's your desired let available date?",
                            "description": "Select your desired move-in date - we'll notify you about listings ±10 days around that date. If there's no let available date mentioned in the ad, we'll still send you the listing.\n",
                            "inputType": "date"
                        },
                        {
                            "type": "checkbox",
                            "name": "furnish_types",
                            "title": "🛋️ What's your desired furnish type?",
                            "description": "Select all options you're comfortable with.",
                            "choices": [
                                {
                                    "value": "furnished",
                                    "text": "Furnished"
                                },
                                {
                                    "value": "part_furnished",
                                    "text": "Part-furnished"
                                },
                                {
                                    "value": "unfurnished",
                                    "text": "Unfurnished"
                                }
                            ]
                        },
                        {
                            "type": "slider",
                            "name": "bathrooms",
                            "title": "🛁  What's the number of bathrooms you need?",
                            "description": "Select the minimum and maximum number of bathrooms you'll consider.",
                            "sliderType": "range",
                            "min": 1,
                            "max": 5,
                            "labelCount": 5
                        },
                        {
                            "type": "dropdown",
                            "name": "flat_size_min",
                            "title": "🏡 What's your minimum desired flat size in sq m?",
                            "description": "Select the minimum flat size you're looking for, and we'll send you listings that match or exceed your preferred size.\n",
                            "placeholder": "1 sq m ≈ 10 sq ft",
                            "choicesMin": 30,
                            "choicesMax": 400,
                            "choicesStep": 20
                        },
                        {
                            "type": "slider",
                            "name": "deposit_max",
                            "title": "💰 What's the maximum deposit you're willing to pay?",
                            "description": "If there's no information available on the deposit in the ad, we'll still send you the listing.",
                            "max": 20000,
                            "step": 200
                        },
                        {
                            "type": "boolean",
                            "name": "exclude_noisy_streets",
                            "title": "🌳 Hide busy/noisy streets?",
                            "description": "We'll exclude properties on major roads, based on OpenStreetMap road classification. Properties we can't classify are still shown.",
                            "defaultValue": false
                        }
                    ]
                },
                {
                    "type": "text",
                    "name": "matched_properties",
                    "visibleIf": "{locations} notempty or {postcode_has_selection} = true or ({location_type} = 'commute' and {commute_filter} notempty)",
                    "title": "📊 Approximate number of properties matching your criteria",
                    "description": "Number of properties in the past two weeks that match your criteria.",
                    "readOnly": true,
                    "inputType": "number"
                }
            ]
        }
    ]
};
